import { render, staticRenderFns } from "./VenueHireDetailsTable.vue?vue&type=template&id=6494d29e&scoped=true&"
import script from "./VenueHireDetailsTable.vue?vue&type=script&lang=js&"
export * from "./VenueHireDetailsTable.vue?vue&type=script&lang=js&"
import style0 from "./VenueHireDetailsTable.vue?vue&type=style&index=0&id=6494d29e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6494d29e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSystemBar } from 'vuetify/lib/components/VSystemBar';
installComponents(component, {VSimpleTable,VSpacer,VSystemBar})
